import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import it from 'vuetify/lib/locale/it';
import minifyTheme from 'minify-css-string'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            minifyTheme,
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#222b54',
                secondary: '#424242',
                accent: '#2d396c',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            }
        },
    },
    lang: {
        locales: { it },
        current: 'it',
    },
});